/**
 * @generated SignedSource<<b6821b28052fe1c8c79014e7030837c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type IssueFieldSingleSelectOptionColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type FieldEditorsFieldSingleSelectValue$data = {
  readonly color: IssueFieldSingleSelectOptionColor;
  readonly description: string | null | undefined;
  readonly field: {
    readonly id?: string;
    readonly name?: string;
  };
  readonly name: string;
  readonly " $fragmentType": "FieldEditorsFieldSingleSelectValue";
};
export type FieldEditorsFieldSingleSelectValue$key = {
  readonly " $data"?: FieldEditorsFieldSingleSelectValue$data;
  readonly " $fragmentSpreads": FragmentRefs<"FieldEditorsFieldSingleSelectValue">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FieldEditorsFieldSingleSelectValue",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "field",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            (v0/*: any*/)
          ],
          "type": "IssueFieldSingleSelect",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    }
  ],
  "type": "IssueFieldSingleSelectValue",
  "abstractKey": null
};
})();

(node as any).hash = "2b97351136928a865a82ad20f1f74b65";

export default node;
